export enum Route {
  HOME = '/',
  GENERAL = '/general',
  HOME_SETUP = '/home-setup',
  PAGES = '/pages',
  CONTENT = '/content',
  EVENTS = '/events',
  PERSONAS = '/personas',
  QUESTIONS = '/questions',
  HISTORY = '/history',
  JSON_SETUP = '/json-setup',
}
